export default "__VITE_ASSET__Bo4KjEKi__"